module.exports = __webpack_public_path__ + "img/A58A0441.e1018ad1.jpg";